'use strict'

loader.$inject = ['$rootScope']

function loader ($rootScope) {
  return function ($scope, element, attrs) {
    $scope.$on('loader_show', function () {
      document.getElementById('gc-load').style.display = 'flex'
    })
    $scope.$on('loader_hide', function () {
      document.getElementById('gc-load').style.display = 'none'
    })
  }
}

angular.module('app').directive('loader', loader)



//////////////////
// WEBPACK FOOTER
// ./directives/loadingBar/loading-bar.directive.js
// module id = 89
// module chunks = 0